export default __webpack_public_path__ + "static/media/jtriley.f5546861.webp";